// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"8fc6b4a4","32":"bac7f264","61":"0811571c","99":"28a8990f","189":"605450b1","213":"a2c8b6b9","241":"46f8b555","339":"bedab7e6","528":"0b6a7a53","649":"fcb5f6ee","693":"f9ee4f3a","866":"1e30a4be"}[chunkId] + ".chunk.js";
};